import moment from 'moment'

const computeNextAuditDate = (startDate, recurrence, periodType) => {
  if (!startDate || !recurrence || !periodType) return null
  if (!moment(startDate).isValid()) return null

  return moment(startDate).add(Number(recurrence), periodType).toISOString()
}

export default computeNextAuditDate
